import methods from 'globalMethod/methods';

const commonColor = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
export const getLineOptions = (extra) => {
    const {
        xData, seriesData, title, xName, yName,
    } = extra;
    return {
        color: commonColor,
        tooltip: {
            trigger: 'axis',
        },
        title: {
            text: title,
        },
        xAxis: {
            type: 'category',
            data: xData,
            name: xName,
        },
        yAxis: {
            type: 'value',
            name: yName,
        },
        series: [{
            data: seriesData,
            type: 'line',
        }],
    };
};

export const getPiOptions = (extra) => {
    const {
        legendData, seriesData, mainTitle, subTitle, inCircleTitle, labelTitle, labelSuffix = '',
    } = extra;
    return {
        color: commonColor,
        title: {
            text: mainTitle,
            subtext: subTitle,
            left: 'center',
        },
        tooltip: {
            trigger: 'item',
            formatter: `{b} : {c}${labelSuffix} ({d}%)`,
        },
        legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 20,
            bottom: 20,
            data: legendData,
        },
        graphic: {
            type: 'text',
            left: 'center',
            top: 'center',
            style: {
                text: inCircleTitle,
                textAlign: 'center',
                fontSize: '50',
                fill: 'black',
            },
        },
        series: [
            {
                name: labelTitle,
                type: 'pie',
                radius: ['40%', '70%'],
                data: seriesData,
                itemStyle: {
                    normal: {
                        label: {
                            show: true,
                            position: 'inner',
                            formatter: '{c}分',
                        },
                    },
                },
            },
        ],
    };
};

export const defaultImageItem = {
    licenseType: 0, picture: '', idNumber: '', isLongTerm: 0, entityName: '', dateRange: [], picState: '',
};


export const getDefaultLicenseList = () => ({
    typedLicenseList: [
        {
            licenseType: 1, typeText: '营业执照', picture: '', idNumber: '', isLongTerm: 0, entityName: '', dateRange: null,
        },
        {
            licenseType: 4, typeText: '食品经营许可证', picture: '', idNumber: '', isLongTerm: 0, entityName: '', dateRange: null,
        },
        {
            licenseType: 7, typeText: '减免税备案登记表(如有)', picture: '', idNumber: '', isLongTerm: 0, entityName: '', dateRange: null,
        },
    ],
    saleLicenseList: [{
        licenseType: 18, typeText: '销售授权书', picture: '', idNumber: '', isLongTerm: 0, entityName: '', dateRange: null, brandId: '',
    }],
    brandLicenseList: [{
        licenseType: 24, typeText: '商标注册证书', picture: '', idNumber: '', isLongTerm: 0, entityName: '', dateRange: null, brandId: '',
    }],
    brandSaleList: [{
        brandLicenseList: [{
            licenseType: 24, typeText: '商标注册证书', picture: '', idNumber: '', isLongTerm: 0, entityName: '', dateRange: null, brandId: '',
        }],
        saleLicenseList: [{
            licenseType: 18, typeText: '销售授权书', picture: '', idNumber: '', isLongTerm: 0, entityName: '', dateRange: null, brandId: '',
        }],
        hideForm: true,
        brandId: '',
        rowkey: methods.generateId(),
    }],
    untypedLicenseList: [{ ...defaultImageItem, rowkey: methods.generateId() }],
});

export const unmarshalTimeRange = (beginTime, endTime) => {
    if (!beginTime || +beginTime <= 0 || !endTime || +endTime <= 0) {
        return null;
    }
    return [+beginTime, +endTime];
};

export const marshalTimeRange = (dateTimeRange, options = {}) => {
    const {
        beginName = 'beginTime',
        endName = 'endTime',
        beginOffset = 0,
        endOffset = 0,
    } = options;
    const [begin, end] = dateTimeRange || [];
    return {
        [beginName]: +begin > 0 ? (+begin + beginOffset) : -1,
        [endName]: +end > 0 ? (+end + endOffset) : -1,
    };
};
